import { createSlice, PayloadAction } from "@reduxjs/toolkit";

/**
 * Holds the total issues count returned by the backend (`response.data.count`,
 * typed `number` in GetIssuesDataResponse). The reducer replaces the whole state
 * with the numeric payload.
 */
type IssuesCountState = number;

// Before any fetch resolves there is no known count, so the store starts at zero. The only
// consumer compares it against the number of loaded issues (`issueCount > loaded`), which the
// legacy `{}` placeholder also made false via NaN comparison — zero keeps that, honestly typed.
const initialState: IssuesCountState = 0;

const issueCountSlice = createSlice({
  name: "issueCount",
  initialState,
  reducers: {
    setIssuesCount: (_state: IssuesCountState, action: PayloadAction<IssuesCountState>) => action.payload,
  },
});

export const { setIssuesCount } = issueCountSlice.actions;

export const issueCount = issueCountSlice.reducer;

export default issueCountSlice.reducer;
